export default __webpack_public_path__ + "static/media/build.62b4444f.webp";